var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInterior(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 86.02 86.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    className: "cls-1",
    d: "M84.7,1.32a4.38,4.38,0,0,0-6.21-.06l-.06.06L39,40.85V27.5a4.39,4.39,0,1,0-8.78,0h0V51.38a3.79,3.79,0,0,0,.11.88V53l.22.44.22.33h0a4.33,4.33,0,0,0,1.43,1.33l.33.22.44.21H58.54a4.39,4.39,0,0,0,0-8.78H45.22L84.75,7.49a4.38,4.38,0,0,0,0-6.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    className: "cls-1",
    d: "M15.38,86H63A15.41,15.41,0,0,0,78.43,70.63V41.8a4.4,4.4,0,0,0-8.79,0V70.63a6.59,6.59,0,0,1-6.58,6.59H15.41a6.59,6.59,0,0,1-6.59-6.59V23a6.59,6.59,0,0,1,6.59-6.59H44.24a4.4,4.4,0,0,0,0-8.79H15.41A15.41,15.41,0,0,0,0,23V70.66A15.41,15.41,0,0,0,15.41,86.07Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterior);
export default __webpack_public_path__ + "static/media/interior.a5b1272d341f521798c3b14a15553977.svg";
export { ForwardRef as ReactComponent };